import meta from './meta';
import general from './general';
import nav from './nav';
import auth from './auth';
import alerts from './alerts';
import tooltips from './tooltips';
import filters from './filters';
import resellers from './resellers/resellers';
import clients from './clients/clients';
import icecatLanguages from './icecat/languages';

const nl = {

    'locales.preferred_language': 'Voorkeurstaal',

    'locales.dutch': 'Nederlands',
    'locales.english': 'English',
    'locales.german': 'Deutsch',

    ...meta,
    ...general,
    ...nav,
    ...auth,
    ...alerts,
    ...tooltips,
    ...resellers,
    ...clients,
    ...filters,
    ...icecatLanguages,
};

export default nl;
